export const trialBalanceFilterState = () => ({
  searchKey: '',
  status: 'all',
  route: 'all',
  user: null,
  page: 1,
  perPage: 10,
  orderBy: 'transactedAt',
  order: 'desc'
});
